import { render, staticRenderFns } from "./MediaCategoryPanel.vue?vue&type=template&id=1c596ec3"
import script from "./MediaCategoryPanel.vue?vue&type=script&lang=js"
export * from "./MediaCategoryPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports